<template>
  <div>
    <slotBase :bg-grey="true">
      <template v-slot:title>
        <titleBar :header-title="'Pilih Layanan'" @back="back" />
      </template>

      <template v-slot:content>
        <div
          class="main-content d-flex flex-column align-items-start p-x-20"
          style="gap: 16px"
          v-if="!isLoading"
        >
          <div class="top-notify mt-4 align-items-start d-grid mx-2">
            <p class="my-0 f-Overpass f-w-600 f-16">
              {{ dataLayanan.data_mesin.nama }}
            </p>
            <p class="my-0 f-Overpass f-w-400 f-14 f-c-grey">
              Pilih layanan yang tersedia untuk mesin ini.
            </p>
          </div>
          <template v-for="(layanan, index) in dataLayanan.data_layanan">
            <cardLayanan
              :nama="layanan.nama"
              :durasi="layanan.durasi"
              :harga="layanan.harga"
              :key="index"
              :index="index"
              :idLayanan="layanan.id"
              :idmesin="dataLayanan.data_mesin.id"
              :namaMesin="dataLayanan.data_mesin.nama"
              :idoutlet="layanan.idoutlet"
            />
          </template>
        </div>
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import titleBar from "@/components/design/titleBar.vue";
import cardLayanan from "../components/cardLayanan.vue";
import { mapActions, mapState } from "vuex";
import VueJwtDecode from "vue-jwt-decode";

export default {
  name: "pilihLayanan",
  components: {
    slotBase,
    titleBar,
    cardLayanan,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  async mounted() {
    if (this.dataLayanan.length != 0) { // cek apakah ada data layanan (untuk refresh page)
      this.isLoading = false;
      return
    }
    if (this.layananApiScan.length == 0) {
      this.$router.replace({ name: "scanMesin" });
    }
    const tokenData = VueJwtDecode.decode(localStorage.getItem("token"));
    let id_customer_global = tokenData.id_customer_global;
    await this.getCustomerGlobal(id_customer_global).then(() => {
      // console.log("dataCustomer:", this.dataGlobalCustomer);
      let dataEpay = 0;
      for (let i = 0; i < this.dataGlobalCustomer.customer.length; i++) {
        const customer = this.dataGlobalCustomer.customer[i];
        if (
          customer.outlet !== null &&
          customer.quota_emoney !== null &&
          customer.quota_emoney.saldo !== 0) {
            if (customer.quota_emoney.jenis_emoney == 2) {
              dataEpay += 1;
            } else if (customer.quota_emoney.masa_aktif >= new Date().getTime()) {
              dataEpay += 1;
            }
        }
      }
      this.getListLayanan(dataEpay);
      // console.log(dataEpay);
    });
  },

  computed: {
    ...mapState("scan", {
      layananApiScan: "layananApiScan",
      dataLayanan: "dataLayanan",
      dataGlobalCustomer: "dataGlobalCustomer",
    }),
  },

  methods: {
    ...mapActions({
      postLayananScan: "scan/postLayananScan",
      getCustomerGlobal: "scan/getCustomerGlobal",
      getCustomerByID: "dashboard/getCustomerByID",
    }),

    async getListLayanan(dataEpay) {
      const query = this.$route.query;
      query.limit = parseInt(query.limit);
      query.skip = parseInt(query.skip);
      await this.postLayananScan(query).then((res) => {
          if (res.status !== 200) {
            this.$toast.error("Mesin Not found", { position: "top" });
            this.isLoading = false;
          } else {
            if (dataEpay > 0) {
              // console.log("Success condition met");
              this.$store.commit("scan/addPaginationScan", query);
              this.$toast.success("Get Layanan Success", { position: "top" });
              this.isLoading = false;
            } else {
              // console.log("Error condition met");
              this.$toast.error("Quota E-Money or Outlet Not Found", {
                position: "top",
              });
              this.isLoading = false;
              this.$refs.modalScan.open();
            }
          }
        });
    },

    back() {
      this.$router.replace({ name: "scanMesin" });
    },
  },
};
</script>
